import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { TreeDragDropService } from 'primeng/api';
import { FileModel } from '../../typescript-angular-client/model/fileModel';

@Injectable({
  providedIn: 'root'
})
export class FmTreeService {
  private fileSelectionChange$ = new BehaviorSubject<FileModel>(null);
  private fileListLoaded$ = new BehaviorSubject<FileModel[]>([]);
  private startDrag$ = new Subject<FileModel | FileModel[]>();
  private stopDrag$ = new Subject<FileModel | FileModel[]>();

  constructor(private ddService: TreeDragDropService) { }

  get SelectionChangeCommand(): Observable<FileModel> {
    return this.fileSelectionChange$.asObservable().pipe(share());
  }

  get fileLoaded(): Observable<FileModel[]> {
    return this.fileListLoaded$.asObservable().pipe(share());
  }

  public onStartDrag = () => this.startDrag$.asObservable();

  public onStoptDrag = () => this.stopDrag$.asObservable();

  public startDrag = (model: FileModel | FileModel[]): void => {
    this.startDrag$.next(model);

    if ((model as FileModel).Id === undefined) {
      return;
    }

    const node = model as FileModel;
    this.ddService.startDrag({
      index: 0,
      scope: 'folder-tree',
      subNodes: [],
      tree: null,
      node: {
        draggable: true,
        droppable: true,
        key: node.Id,
        label: node.Name,
        data: node
      }
    });
  }

  public stopDrag = (model: FileModel | FileModel[]): void => {
    this.stopDrag$.next(model);

    if ((model as FileModel).Id === undefined) {
      return;
    }

    const node = model as FileModel;
    this.ddService.stopDrag({
      index: 0,
      scope: 'folder-tree',
      subNodes: [],
      tree: null,
      node: {
        draggable: true,
        droppable: true,
        key: node.Id,
        label: node.Name,
        data: node
      }
    });
  }
}
